import { DELETE_LABEL, UNSHARE_LABEL } from '../../common/ActionLabels';
import * as ItemUtils from '../../common/ItemTools';
import { favoriteActionTitle } from '../common/FavoriteIcon';

// The footer actions a card has stopped showing, in the order they sit in the
// footer. A share with nothing left to propose is a marker rather than an
// action, so it has nothing to offer here.
function collapsedEntries(item, options) {
  const {
    isHidden, onItemBookmark, onItemShare, onItemHide, onItemMarkReviewed, onItemFavorite,
  } = options;
  const entries = [];

  if (onItemBookmark && item.hasPublicData) {
    entries.push({
      label: item.hasPrivateData ? 'Remove the private copy' : 'Save a private copy',
      action: () => onItemBookmark(item),
    });
  }
  const shareIsMarker = Boolean(item.hasPublicData)
    && ItemUtils.shareChangesState(item.shareDiff) === 'none';
  if (onItemShare && item.hasPrivateData && !isHidden && !shareIsMarker) {
    entries.push({
      label: item.hasPublicData ? 'Share changes' : 'Share',
      action: () => onItemShare(item),
    });
  }
  if (onItemHide && isHidden) {
    entries.push({ label: 'Unhide', action: () => onItemHide(item) });
  }
  if (onItemMarkReviewed) {
    entries.push({
      label: item.timeReviewed ? 'Mark unreviewed' : 'Mark reviewed',
      action: () => onItemMarkReviewed(item),
    });
  }
  if (onItemFavorite) {
    entries.push({
      label: favoriteActionTitle(Boolean(item.isFavorite)),
      action: () => onItemFavorite(item),
    });
  }
  return entries;
}

/**
 * The ⋮ menu's entries. What the footer has no room for comes first: an action
 * the card drops moves here rather than being lost, which is why `collapsed`
 * and `composerCollapsed` have to say what the footer is still showing.
 */
export default function buildMenuOptions(options) {
  const {
    item, moderating, isHidden, collapsed, composerCollapsed,
    onItemEdit, onItemClone, onItemHide, onItemDelete, onItemUnshare,
    onAddToList, onAddTag,
  } = options;

  const entries = [];
  if (collapsed && !moderating) {
    entries.push(...collapsedEntries(item, options));
  }
  if (composerCollapsed) {
    entries.push({ label: 'Add tag', action: onAddTag });
  }
  if (onItemEdit) {
    entries.push({ label: 'Edit', action: () => onItemEdit(item) });
  }
  if (!moderating) {
    entries.push({ label: 'Add to list', action: onAddToList });
    if (onItemClone) {
      entries.push({ label: 'Make a copy', action: () => onItemClone(item) });
    }
    if (onItemHide && !isHidden) {
      entries.push({ label: 'Hide', action: () => onItemHide(item) });
    }
    if (onItemDelete && item.hasPrivateData) {
      entries.push({ label: DELETE_LABEL, action: () => onItemDelete(item) });
    }
    if (onItemUnshare && item.hasPublicData) {
      entries.push({ label: UNSHARE_LABEL, action: () => onItemUnshare(item) });
    }
  }
  return entries.map((entry, index) => ({ ...entry, id: index + 1 }));
}
